var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LobbyControllerApiFactory } from "@/apis/lobby-management";
import { TableControllerApiFactory } from "@/apis/table-management";
import AlertModal from "@/components/AlertModal";
import AlertIcon from "@/components/Icons/AlertIcon";
import InfinityTable from "@/components/Infinitytable";
import { LocalStorageKeys } from "@/constants/localStorage";
import { useApi } from "@/hooks/useApi";
import { Card, Divider, message } from "@atom/ui-kit";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { columns } from "./TableManagement.columns";
import TableManagementFilterSpace from "./TableManagement.filters";
var DEFAULT_PAGE_SIZE = 20;
var TableManagement = function () {
    var navigate = useNavigate();
    var t = useTranslation().t;
    var searchParams = new URLSearchParams(window.location.search);
    var lobbyIdFromQuery = searchParams.get("lobbyId");
    var _a = useState({
        tenant: localStorage.getItem(LocalStorageKeys.TENANT) || "wisegaming",
        limit: DEFAULT_PAGE_SIZE,
        requestType: lobbyIdFromQuery ? "lobbyId" : "type",
        type: "texasholdem",
        lobbyId: lobbyIdFromQuery || "",
    }), reqParams = _a[0], setReqParams = _a[1];
    var _b = useState([]), tableData = _b[0], setTableData = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(""), lastEvaluatedKey = _d[0], setLastEvaluatedKey = _d[1];
    var _e = useState(false), isAlertOpen = _e[0], setIsAlertOpen = _e[1]; // AlertModal için state
    var _f = useState(null), selectedTableId = _f[0], setSelectedTableId = _f[1]; // Silinecek tablo ID'sini tutmak için
    var fetchTableData = function (lastEvaluatedKeyParam) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, params, _a, error_1;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 13, 14, 15]);
                    setLoading(true);
                    params = __assign(__assign({}, reqParams), { lastKey: lastEvaluatedKeyParam || lastEvaluatedKey, lobbyId: reqParams.lobbyId });
                    _a = reqParams.requestType;
                    switch (_a) {
                        case "all": return [3 /*break*/, 1];
                        case "lobbyId": return [3 /*break*/, 3];
                        case "type": return [3 /*break*/, 5];
                        case "tableId": return [3 /*break*/, 7];
                        case "tableName": return [3 /*break*/, 9];
                    }
                    return [3 /*break*/, 11];
                case 1: return [4 /*yield*/, TableControllerApiFactory().tablesTenantTenantGet(params)];
                case 2:
                    response_1 = (_f.sent());
                    setTableData(function (prev) { return __spreadArray(__spreadArray([], prev, true), response_1.data.data.tables, true); });
                    setLastEvaluatedKey(response_1.data.data.lastEvaluatedKey);
                    return [3 /*break*/, 12];
                case 3: return [4 /*yield*/, TableControllerApiFactory().tablesTenantTenantLobbyIdLobbyIdGet({
                        lobbyId: reqParams.lobbyId,
                        tenant: reqParams.tenant,
                        lastEvaluatedKey: lastEvaluatedKeyParam || lastEvaluatedKey,
                        limit: DEFAULT_PAGE_SIZE,
                    })];
                case 4:
                    response_1 = (_f.sent());
                    setTableData(function (prev) { var _a, _b; return __spreadArray(__spreadArray([], prev, true), (_b = (_a = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.items, true); });
                    setLastEvaluatedKey((_c = (_b = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.lastEvaluatedKey);
                    return [3 /*break*/, 12];
                case 5: return [4 /*yield*/, TableControllerApiFactory().tablesTenantTenantTypeTypeGet(__assign(__assign({}, params), { type: reqParams.type, limit: DEFAULT_PAGE_SIZE }))];
                case 6:
                    response_1 = (_f.sent());
                    setTableData(function (prev) { var _a, _b; return __spreadArray(__spreadArray([], prev, true), (_b = (_a = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.items, true); });
                    setLastEvaluatedKey((_e = (_d = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.lastEvaluatedKey);
                    return [3 /*break*/, 12];
                case 7: return [4 /*yield*/, TableControllerApiFactory().tablesTenantTenantIdIdGet({
                        id: reqParams.tableId,
                        tenant: reqParams.tenant,
                    })];
                case 8:
                    response_1 = (_f.sent());
                    setTableData([response_1.data.data]);
                    return [3 /*break*/, 12];
                case 9: return [4 /*yield*/, TableControllerApiFactory().tablesTenantTenantNameNameGet({
                        name: reqParams.tableName,
                        tenant: reqParams.tenant,
                    })];
                case 10:
                    response_1 = (_f.sent());
                    setTableData([response_1.data.data]);
                    return [3 /*break*/, 12];
                case 11:
                    message.error("Invalid request type");
                    return [2 /*return*/];
                case 12: return [3 /*break*/, 15];
                case 13:
                    error_1 = _f.sent();
                    console.log("Failed to fetch table data");
                    return [3 /*break*/, 15];
                case 14:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var _g = useApi({
        asyncFunction: TableControllerApiFactory().tablesTenantTenantIdIdDelete,
        successCallback: function (response) {
            message.success(t("root.delete_success"));
            fetchTableData();
        },
        errorCallback: function (error) {
            message.error(t("root.delete_error"));
        },
    }), callDeleteTableManagement = _g.call, deleteTableManagementLoading = _g.loading;
    var _h = useApi({
        asyncFunction: LobbyControllerApiFactory().lobbiesTenantTenantGet,
    }), callLobbyManagementList = _h.call, lobbyManagementData = _h.data;
    var handleDelete = function (key) {
        setSelectedTableId(key || null);
        setIsAlertOpen(true);
    };
    var handleEdit = function (key, tenant) {
        navigate("/table-management/".concat(key, "?tenant=").concat(tenant));
    };
    var handleAdd = function () {
        navigate("/table-management/add");
    };
    var handlGameDetail = function (recordData) { };
    var handleOpenTransactionDetail = function (recordData) { };
    var handleSearch = function (values) {
        setTableData([]);
        setLastEvaluatedKey("");
        setReqParams(__assign(__assign(__assign({}, reqParams), values), { requestType: values.lobbyId ? "lobbyId" : values.type ? "type" : values.tableId ? "tableId" : values.tableName ? "tableName" : "all" }));
    };
    var handleConfirmDelete = function () {
        if (selectedTableId) {
            callDeleteTableManagement({
                id: selectedTableId,
                tenant: localStorage.getItem(LocalStorageKeys.TENANT) || "wisegaming",
            });
        }
        setIsAlertOpen(false);
    };
    var loadMore = useCallback(function () {
        if (reqParams.requestType === "all" || reqParams.requestType === "type" || reqParams.requestType === "lobbyId") {
            fetchTableData(lastEvaluatedKey);
        }
    }, [lastEvaluatedKey, reqParams.requestType]);
    useEffect(function () {
        fetchTableData();
        callLobbyManagementList({
            tenant: localStorage.getItem(LocalStorageKeys.TENANT) || "wisegaming",
        });
    }, [reqParams]);
    return (_jsxs(Card, { style: {
            padding: "20px 0",
            height: "80vh",
        }, children: [_jsx(TableManagementFilterSpace, { onAddNewData: handleAdd, onSearch: handleSearch }), _jsx(Divider, {}), _jsx(InfinityTable, { columns: columns(handleOpenTransactionDetail, handlGameDetail, handleEdit, handleDelete, t, lobbyManagementData === null || lobbyManagementData === void 0 ? void 0 : lobbyManagementData.data), dataSource: tableData || [], loading: loading || deleteTableManagementLoading, hasMore: Boolean(lastEvaluatedKey), onLoadMore: loadMore }), _jsx(AlertModal, { isOpen: isAlertOpen, title: t("root.delete_confirmation_title"), message: t("When you delete the table. At the end of the ongoing game, the table will be closed."), confirmLabel: t("root.confirm"), cancelLabel: t("root.cancel"), onConfirm: handleConfirmDelete, onCancel: function () { return setIsAlertOpen(false); }, icon: _jsx(AlertIcon, {}) })] }));
};
export default TableManagement;
